import {
  Carousel,
  Typography,
  TypographyVariants,
  TypographyColors,
  TypographyAligns,
} from '@carboledger/ui';
import { MassBalanceVisual, DeclarationVisual, StandardsVisual } from './AuthCarouselVisuals';
import { useTranslations } from '@/hooks';
import styles from './AuthLayout.module.scss';

const SLIDES = [
  {
    key: 'mass-balance',
    headingKeys: ['AUTH_SLIDE_MB_HEADING_1', 'AUTH_SLIDE_MB_HEADING_2'],
    bodyKey: 'AUTH_SLIDE_MB_BODY',
    Visual: MassBalanceVisual,
  },
  {
    key: 'declarations',
    headingKeys: ['AUTH_SLIDE_DECL_HEADING'],
    bodyKey: 'AUTH_SLIDE_DECL_BODY',
    Visual: DeclarationVisual,
  },
  {
    key: 'standards',
    headingKeys: ['AUTH_SLIDE_STD_HEADING'],
    bodyKey: 'AUTH_SLIDE_STD_BODY',
    Visual: StandardsVisual,
  },
];

const AuthFooter = () => {
  const t = useTranslations();
  return (
    <div className={styles.footer}>
      <a className={styles.footerLink} href="mailto:hello@carboledger.io">
        {t('AUTH_FOOTER_CONTACT')}
      </a>
      <a className={styles.footerLink} href="/privacy">
        {t('AUTH_FOOTER_PRIVACY')}
      </a>
      <a className={styles.footerLink} href="/terms">
        {t('AUTH_FOOTER_TERMS')}
      </a>
    </div>
  );
};

/**
 * Props:
 *   children   the right-pane form content (a login/OTP form)
 */
export const AuthLayout = ({ children }) => {
  const t = useTranslations();
  return (
    <div className={styles.root}>
      <div className={styles.visual}>
        <Carousel>
          {SLIDES.map(({ key, headingKeys, bodyKey, Visual }) => (
            <Carousel.Slide key={key}>
              <Visual />
              <Typography
                variant={TypographyVariants.h5}
                color={TypographyColors.onBrand}
                align={TypographyAligns.center}
              >
                {headingKeys.length > 1
                  ? headingKeys.map((headingKey, index) => (
                      <span key={headingKey}>
                        {index > 0 && <br />}
                        {t(headingKey)}
                      </span>
                    ))
                  : t(headingKeys[0])}
              </Typography>
              <Typography
                variant={TypographyVariants.bodySm}
                color={TypographyColors.onBrand}
                align={TypographyAligns.center}
              >
                {t(bodyKey)}
              </Typography>
            </Carousel.Slide>
          ))}
        </Carousel>
      </div>
      <div className={styles.content}>
        <div className={styles.form}>{children}</div>
        <AuthFooter />
      </div>
    </div>
  );
};
